import { reactive } from 'vue'
import api from '../../api/v2/api'
import UserInquiryForm from '../../api/v2/forms/user_inquiry'

class UserInquiryState {
  async create(userInquiryForm: UserInquiryForm){
    return await api.inquiry.create(userInquiryForm)
  }
  async update(inquiryId: number, userInquiryForm: UserInquiryForm){
    return await api.inquiry.update(inquiryId, userInquiryForm)
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const userInquiryState = reactive(new UserInquiryState()) as UserInquiryState
